export const wardrobes = {
    shkaf__shk__1060: {
        name: "Шкаф для комплектующих (ШК), мм",
        title: "Шкаф для комплектующих (ШК)",
        price: 0,
        active: false,
        type: "1060x820x450",
        height: 1060,
        width: 820,
        depth: 450,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    shkaf__shk__1850: {
        name: "Шкаф для комплектующих (ШК), мм",
        title: "Шкаф для комплектующих (ШК)",
        price: 0,
        active: false,
        type: "1850x820x450",
        height: 1850,
        width: 820,
        depth: 450,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    shkaf__sha__1000: {
        name: "Шкаф для комплектующих (ШA), мм",
        title: "Шкаф для комплектующих (ШA)",
        price: 0,
        active: false,
        type: "1000x850x450",
        height: 1000,
        width: 850,
        depth: 450,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    shkaf__sha__1850: {
        name: "Шкаф для комплектующих (ШA), мм",
        title: "Шкаф для комплектующих (ШA)",
        price: 0,
        active: false,
        type: "1850x850x450",
        height: 1850,
        width: 850,
        depth: 450,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    shkaf__sha__1950: {
        name: "Шкаф для комплектующих (ШA), мм",
        title: "Шкаф для комплектующих (ШA)",
        price: 0,
        active: false,
        type: "1950x1000x550",
        height: 1950,
        width: 1000,
        depth: 550,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    shkaf__shi__2000: {
        name: "Шкаф инструментальный (ШИ), мм",
        title: "Шкаф инструментальный (ШИ)",
        price: 0,
        active: false,
        type: "2000x1020x620",
        height: 2000,
        width: 1020,
        depth: 620,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    shkaf__shir__2000: {
        name: "Шкаф инструментальный (ШИР), мм",
        title: "Шкаф инструментальный (ШИР)",
        price: 0,
        active: false,
        type: "2000x1020x620",
        height: 2000,
        width: 1020,
        depth: 620,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    shkaf__ship__2000: {
        name: "Шкаф инструментальный (ШИП), мм",
        title: "Шкаф инструментальный (ШИП)",
        price: 0,
        active: false,
        type: "2000x1020x620",
        height: 2000,
        width: 1020,
        depth: 620,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    shkaf__shio__2000: {
        name: "Шкаф инструментальный (ШИО), мм",
        title: "Шкаф инструментальный (ШИО)",
        price: 0,
        active: false,
        type: "2000x1020x620",
        height: 2000,
        width: 1020,
        depth: 620,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
};

export const polka__wardrobes = {
    polka__shkaf__sha__450: {
        name: "Дополнительная полка, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
    polka__shkaf__sha__500: {
        name: "Дополнительная полка, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
    polka__shkaf__sha__550: {
        name: "Дополнительная полка, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
};
